import REQUEST_KEY from '@common/constants/requestKeys';
import { ClientError } from '@common/helpers/errors';
import { useHandleAppLoading } from '@common/hooks/appLoading';

// The jobs.actions.upgradeWithCoins BFF procedure was decommissioned along with
// je-client / je-credit-service. This hook is retained as an inert stub so
// obsolete upgrade UI still compiles; upgrading with coins is no longer wired
// to a backend.
export const useUpgradeJobWithCoinsMutation = () => {
  const upgradeJobMutation = {
    mutate: (_variables?: any) => undefined,
    error: null as any,
    isLoading: false,
    isSuccess: false
  };

  useHandleAppLoading(
    upgradeJobMutation.isLoading,
    REQUEST_KEY.JOB.ACTION.UPGRADE
  );

  return {
    upgradeJobWithCoins: upgradeJobMutation.mutate,
    errorMessage: getClientError(upgradeJobMutation.error),
    isSuccessful: upgradeJobMutation.isSuccess
  };
};

const getClientError = (error) => {
  if (!error) return;

  const guid = error?.data?.httpError.guid;
  const responseBody = error?.data;

  return new ClientError('errors.defaultWithGuid', {
    guid,
    responseBody
  });
};
